// Enum listant les permissions (un droit par page / feuille de navigation)
// IMPORTANT: créer/aligner ces codes côté backend (Group/Permission) pour que le filtrage fonctionne.
export enum PagePermission {
  DashboardLilate = 'manage-menu-dashboard-lilate',
  LilatesListe = 'manage-menu-lilates-liste',
  LilatesDuJour = 'manage-menu-lilates-dujour',
  TestsLilate = 'manage-menu-tests-lilate',
  TestsEvaluationSlides = 'manage-menu-tests-evaluation-slides',
  TestsContextSlides = 'manage-menu-tests-context-slides',
  Elates = 'manage-menu-elates',
  PartnersListe = 'manage-menu-partners-liste',
  StudentsListe = 'manage-menu-students-liste',
  EntreprisesSection = 'manage-menu-entreprises-section',
  ReferentialBusiness = 'manage-menu-referential-business',
  ReferentialJobs = 'manage-menu-referential-jobs',
  ExportMain = 'manage-menu-export-main'
}